import { StoreMenuParams } from 'common/types/params'
import { StoreMenu } from 'common/types/entities/mongo/storeMenu'
import { axios } from 'common/utils'

export const fetchStoreMenus = async (params: StoreMenuParams): Promise<StoreMenu[]> => {
  const result = await axios.get<StoreMenu[]>('/v1/store-menus', {
    params,
  })
  return (result && result.data) || []
}
